import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card, Button, Dropdown, Spinner } from "react-bootstrap";
// import TaskComments from "../components/tasks/TaskComments";
// import TaskAttachments from "../components/tasks/TaskAttachments";
import TaskChat from "../components/tasks/TaskChat";
import ChatBox from "../components/tasks/ChatBox";

const TaskDetailsPage = () => {
  const { taskId } = useParams();
  const [task, setTask] = useState(null);
  const [error, setError] = useState(null);
  const authToken = localStorage.getItem("auth_token");

  useEffect(() => {
    fetch(`https://loopsneller.com/api/tasks/${taskId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok)
          throw new Error(`Error ${response.status}: Unable to fetch task`);
        return response.json();
      })
      .then((data) => setTask(data))
      .catch((error) => setError(error.message));
  }, [taskId]);

  const handleStatusChange = (newStatus) => {
    fetch(`https://loopsneller.com/api/tasks/${taskId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ status_id: newStatus.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        // ✅ Use the "task" key from the backend response
        setTask(data.task);
      })
      .catch((err) => console.error("Failed to update status:", err));
  };

  if (error)
    return <div className="alert alert-danger text-center my-5">{error}</div>;
  if (!task)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
      </div>
    );

  return (
    <div className="container mt-4">
      <Card className="p-4 shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>{task.title}</h2>
          <Dropdown>
            <Dropdown.Toggle variant="primary">
              {task.status.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => handleStatusChange({ id: 1, name: "To-Do" })}
              >
                To-Do
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  handleStatusChange({ id: 2, name: "In Progress" })
                }
              >
                In Progress
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleStatusChange({ id: 3, name: "Done" })}
              >
                Done
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <p className="text-muted">{task.description}</p>
        <p className="text-muted">Priority: {task.priority}</p>

        <div className="d-flex justify-content-between align-items-center">
          <span>
            <strong>Project:</strong> {task.project.name}
          </span>
          <span>
            <strong>Assigned To:</strong> {task.user.name}
          </span>
        </div>
      </Card>

      <div className="mt-4">
        <ChatBox taskId={taskId} />
      </div>
      <div className="mt-4 text-center">
        <a href={`/projects/${task.project.id}`} className="btn btn-secondary">
          ← Back to Project
        </a>
      </div>
    </div>
  );
};

export default TaskDetailsPage;
